import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'src/components';
import { useExternalHref } from 'src/hooks/useExternalHref';
import MissionImage from './images/mission.jpg';
import { msgs } from './messages';
import * as S from './styles';

const MissionCard: FC<{
  className?: string;
  mission: string;
  image?: string;
  mode: 'horizontal' | 'vertical';
}> = ({ className, mission, mode, image = MissionImage }) => {
  const { asPath } = useRouter();
  const intl = useIntl();

  const membotDialogHref = useExternalHref({
    linkType: 'memrise-membot',
    query: {
      back: asPath,
      slug: mission,
    },
  });

  const isHorizontal = mode === 'horizontal';
  const ctaMovie = intl.formatMessage(msgs.ctaMovie);
  const ctaCinema = intl.formatMessage(msgs.ctaCinema);
  const titleMovie = intl.formatMessage(msgs.titleMovie);
  const titleCinema = intl.formatMessage(msgs.titleCinema);
  const label = intl.formatMessage(msgs.label);
  const cta = isHorizontal ? ctaMovie : ctaCinema;
  const title = isHorizontal ? titleMovie : titleCinema;

  return (
    <S.MissionCard className={className} $mode={mode}>
      <S.ImageWrapper $mode={mode}>
        <Image alt={title as string} src={image} fill sizes="100vw" />
        <S.ImageLabel>{label}</S.ImageLabel>
      </S.ImageWrapper>
      <S.CallToActionWrapper $mode={mode}>
        <S.Title>{title}</S.Title>
        <Button
          analyticsEvent="none"
          buttonSizeBreakpoint="md"
          buttonType="primary"
          fullWidth="always"
          href={membotDialogHref}
        >
          {cta}
        </Button>
      </S.CallToActionWrapper>
    </S.MissionCard>
  );
};

export default MissionCard;
